import { ReactNode } from 'react';

export enum SideNavId {
    Home = 'Home',
    LiveMessages = 'LiveMessages',
    Messages = 'Messages',
    Snippets = 'Snippets',
    MessageLive = 'MessageLive',
    MessagesDrafts = 'MessagesDrafts',
    MessagesReview = 'MessagesReview',
    MessageScheduled = 'MessageScheduled',
    MessageExpired = 'MessageExpired',
    MessagesArchived = 'MessagesArchived',
    Personalization = 'Personalization',
    Audiences = 'Audiences',
    Datasets = 'Datasets',
    EmailTemplates = 'EmailTemplates',
    Monitoring = 'Monitoring',
    MessagePerformance = 'MessagePerformance',
    Analytics = 'Analytics',
    Inspiration = 'Inspiration',
    Payments = 'Payments',
    Optimized = 'Optimized',
    Controlled = 'Controlled',
    GenAiAssistant = 'GenAiAssistant',
    Documentation = 'Documentation',
    ApiDocumentation = 'ApiDocumentation',
    MessageSettings = 'MessageSettings',
    Triggers = 'Triggers',
    LabelManagement = 'LabelManagement',
    SystemSetup = 'SystemSetup',
    Events = 'Events',
    Funnel = 'Funnel',
    FrequencyLimits = 'FrequencyLimits',
    AccountMembers = 'AccountMembers',
    Integrations = 'Integrations',
    Languages = 'Languages',
    Attributes = 'Attributes',
    FormulaSequences = 'FormulaSequences',
    FormulaSequencesLive = 'FormulaSequencesLive',
    FormulaSequencesDrafts = 'FormulaSequencesDrafts',
    FormulaSequencesArchived = 'FormulaSequencesArchived',
    Insights = 'Insights',
    Surface = 'Surface',
    SurfacePerformance = 'SurfacePerformance',
    AampeAdmin = 'AampeAdmin',
    CreateCustomer = 'CreateCustomer',
    TopicManagement = 'TopicManagement',
    RewardFunctions = 'RewardFunctions',
}

export type SideNavItem = {
    id: SideNavId;
    destination: string;
    text: string;
    icon?: ReactNode;
    isBetaMode?: boolean;
    webLink?: string;
    nxLink?: boolean;
    hasWarning?: boolean;
    warningTooltip?: string;
};
